<script>
import Base from './base.vue';
import autoAdd from '../mixin/auto-add';
import { flowTypes } from '@/common/service/page-config';

export default {
  name: 'BUY_NOW',
  extends: Base,
  mixins: [autoAdd],
  computed: {
    showIncreaseWithLargeMeetingPromo() {
      return [flowTypes.buyNow, flowTypes.basic2pro].includes(this.$context.flow) &&
        !this.$core.draftPlanFilterKeys.includes('LARGE_MEETING') &&
        this.$core.addonFilterKeys.includes('LARGE_MEETING') &&
        !this.isInClientModal
    },
    showLargeMeetingPromoInComparison() {
      return [flowTypes.buyNow, flowTypes.basic2pro].includes(this.$context.flow) &&
        !this.isInClientModal &&
        (
          this.$core.draftPlanFilterKeys.includes('LARGE_MEETING') ||
          this.$core.addonFilterKeys.includes('LARGE_MEETING')
        )
    },
  },
};
</script>
